import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef, ViewEncapsulation } from "@angular/core";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzPaginationI18nInterface } from "ng-zorro-antd/i18n";
import { NzPaginationItemComponent } from "ng-zorro-antd/pagination";
import { PaginationItemRenderContext, PaginationItemType } from "../../pagination.models";

@Component({
  selector: "li[ui-pagination-item]",
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "pagination-item.component.html",
  host: {
    "[attr.title]": "showTooltip ? title : null",
  },
})
export class UiPaginationItemComponent extends NzPaginationItemComponent {
  @Input("active") public active = false;
  @Input("locale") public locale!: NzPaginationI18nInterface;
  @Input("index") public index: number | null = null;
  @Input("disabled") public disabled = false;
  @Input("direction") public direction = "ltr";
  @Input("type") public type: PaginationItemType | string | null = null;
  // Design wants no tooltips in the custom reflection paginator implementation
  // This is a workaround to disable it as NgZorro doesn't have an API to control that.
  @Input("uiShowTooltip") @InputBoolean() public showTooltip = true;
  @Input("itemRender") public itemRender: TemplateRef<PaginationItemRenderContext> | null = null;
  @Output("diffIndex") public readonly diffIndex = new EventEmitter<number>();
  @Output("gotoIndex") public readonly gotoIndex = new EventEmitter<number>();
}
